import React, { useRef } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';
import ZigZagGrid from '../../../Global/Grid/ZigZagGrid';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import IdealzBg from '../../../../Images/background/bg_camp-idealz.png';
import LogoStudio from '../../../../Images/logos/logo-studio.png';

import {
  Idealz_Title,
  Title_1,
  Title_2,
  Title_3,
  Title_4,
  First_Row,
  Second_Row,
  Third_Row,
  Fourth_Row,
} from '../../../../utils/ES/Modals/campIdealz';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 25px 60px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 2.5rem;

  p,
  h2,
  h3 {
    text-transform: uppercase;
  }
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;

  p,
  h2,
  h3 {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(250, 115, 19, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const VideoFrame = styled.iframe`
  width: 100%;
  max-width: 100%;
  height: 594px;
  border: none;

  @media (max-width: ${breakpoints.mobile}) {
    height: 150px;
  }
`;

const VideosContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 2rem;

  @media (max-width: ${breakpoints.mobile}) {
    gap: 1rem;
  }

  iframe {
    max-width: 468px;
    width: 100%;
    height: 732px;

    @media (max-width: ${breakpoints.mobile}) {
      max-width: 45%;
      height: 300px;
    }
  }
`;

const ModalIdealz = () => {
  const { closeModal } = useModal();

  const iframeRef = useRef(null);

  const handleClose = () => {
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src;
    }
    closeModal();
  };

  return (
    <>
      <Modal id="campaign-idealz" bgImg={IdealzBg}>
        <CloseContainer>
          <CloseButton
            onClick={handleClose}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoStudio}
                onClick={handleClose}
                aria-label="Close modal"
                alt="Kuter Studio"
              />
            </LogoContent>
            <RichText dataText={Idealz_Title} />
          </TitleContent>
          <RichText dataText={Title_1} />
          <VideoFrame
            ref={iframeRef}
            src="https://player.vimeo.com/video/1053473405?h=072ad96183&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            allow="autoplay; fullscreen;"
            referrerPolicy="strict-origin-when-cross-origin"
            title="KUTER_STUDIO_IDEALZ"
          />
          <RichText dataText={Title_2} />
          <VideoFrame
            ref={iframeRef}
            src="https://player.vimeo.com/video/1015792025?h=7413069a70&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            allow="autoplay; fullscreen;"
            referrerPolicy="strict-origin-when-cross-origin"
            title="KUTER_STUDIO_IDEALZ"
          />
          <RichText dataText={Title_3} />
          <VideosContainer>
            <VideoFrame
              ref={iframeRef}
              src="https://player.vimeo.com/video/1053487144?h=f03a8b2931&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              allow="autoplay; fullscreen;"
              referrerPolicy="strict-origin-when-cross-origin"
              title="KUTER_STUDIO_IDEALZ"
            />
            <VideoFrame
              ref={iframeRef}
              src="https://player.vimeo.com/video/1053486129?h=1d3171f030&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              allow="autoplay; fullscreen;"
              referrerPolicy="strict-origin-when-cross-origin"
              title="KUTER_STUDIO_IDEALZ"
            />
            <VideoFrame
              ref={iframeRef}
              src="https://player.vimeo.com/video/1053487097?h=7ac50cb00a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              allow="autoplay; fullscreen;"
              referrerPolicy="strict-origin-when-cross-origin"
              title="KUTER_STUDIO_IDEALZ"
            />
            <VideoFrame
              ref={iframeRef}
              src="https://player.vimeo.com/video/1053488632?h=fd9d90efb3&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              allow="autoplay; fullscreen;"
              referrerPolicy="strict-origin-when-cross-origin"
              title="KUTER_STUDIO_IDEALZ"
            />
            <VideoFrame
              ref={iframeRef}
              src="https://player.vimeo.com/video/1053487698?h=e43b2478f1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              allow="autoplay; fullscreen;"
              referrerPolicy="strict-origin-when-cross-origin"
              title="KUTER_STUDIO_IDEALZ"
            />
            <VideoFrame
              ref={iframeRef}
              src="https://player.vimeo.com/video/1053486977?h=c1974ad341&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              allow="autoplay; fullscreen;"
              referrerPolicy="strict-origin-when-cross-origin"
              title="KUTER_STUDIO_IDEALZ"
            />
          </VideosContainer>
          <RichText dataText={Title_4} />
          <ZigZagGrid
            firstRow={First_Row}
            secondRow={Second_Row}
            thirdRow={Third_Row}
            fourthRow={Fourth_Row}
          />
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalIdealz;
